module.exports = __webpack_public_path__ + "07_bob_brown.10276b05.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/07_bob_brown.png
// module id = iOko
// module chunks = 0